import { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { WP_HouseTerm } from '../model/models';
import { ModelsService } from '../services/ModelsService';
import { AppContext } from '../state/AppContextProvider';
import { ActionType } from '../state/GlobalState';
import { useWP } from './WPHooks';

/**
 * Hook useCurrentHouse()
 * Return the current user house name
 * @returns
 */
export const useCurrentHouse = (): undefined | WP_HouseTerm => {
  const { state } = useContext(AppContext);

  const house = state.house
    ? ModelsService.getHouseTerm(state.house.term_id, state.allHouses)
    : undefined;
  return house;
};

/**
 * Hook useHouseName()
 * Return the current user house name
 * @returns
 */
export const useHouseName = () => {
  const { state } = useContext(AppContext);

  const intl = useIntl();

  const houseName =
    ModelsService.getUserHouseName(state.user) ||
    intl.formatMessage({ id: 'Not loded yet' });

  return houseName;
};

/**
 * Hook useHousePages()
 * Fetch all house pages and put it into AppContext
 */
export const useHousePages = (fetch: boolean = false) => {
  const { state, dispatch } = useContext(AppContext);

  const { wp } = useWP();

  useEffect(() => {
    if (
      fetch &&
      state.isConnected &&
      state.user &&
      state.house &&
      state.locale &&
      (state.housePages.length === 0 ||
        state.housePages[0]['tax-house'][0] !== state.house.term_id)
    ) {
      const houseId = state.house.term_id;

      // Get House Pages
      wp.getHousePages(houseId, state.locale).then((housePages) => {
        dispatch({
          type: ActionType.SetHousePages,
          payload: housePages,
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isConnected, state.locale, state.house]);
};

/**
 * Hook useHouses()
 * Fetch all houses and put it into AppContext
 */
export const useHouses = (fetch: boolean = false) => {
  const { dispatch } = useContext(AppContext);

  const { wp, ready } = useWP();

  useEffect(() => {
    if (fetch && ready) {
      // fetch All Houses
      wp.getHouses().then((houses) => {
        dispatch({
          type: ActionType.SetAllHouses,
          payload: houses,
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready]);
};
